import dayjs from "dayjs";

const ItemPrint = (dataList) => {
  return `<!DOCTYPE html>
<html lang="id">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Label Cold Storage</title>
    <style>
        @page {
            size: 48mm 210mm;
            margin: 5mm; /* Margin kecil untuk menghindari pemotongan */
        }
        body {
            font-family: Arial, sans-serif;
            text-align: center;
            margin: 0;
            padding: 0;
            margin-bottom: 10mm;
        }
        .label-container {
            display: block; /* Mengubah dari flex ke block */
            height: 105%;
        }
        .label {
            width: 48mm;
            height: 78mm;
            border: 1px solid black;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 10px;
            box-sizing: border-box;
            break-before: page; /* Memastikan setiap label di halaman baru */
        }
        .title {
            font-size: 18px;
        }
        .rack {
            font-size: 25px;
            margin: 32px 0;
            font-weight: bold;
        }
        .date {
            font-size: 14px;
        }
    </style>
</head>
<body>
    <div class="label-container">
        ${dataList
          ?.map(
            (data) => `
            <div class="label">
                <strong>${data.pallet_name ?? ""}</strong>
                <br/>
                <div class="title">${data.warehouse}</div>
                <div class="rack">${data.area}</div>
                <div class="date">${dayjs(data.scheduleAt).format(
                  "DD-MM-YYYY"
                )}</div>
            </div>
        `
          )
          .join("")}
    </div>
    <br />
    <p>.</p>
</body>
</html>
`;
};

export default ItemPrint;
